module.exports = __webpack_public_path__ + "img/carrousel-arco-digi-4.4960dd03.png";